// Checks whether the phone number has a zero in front
export const phoneNumberRegEx = /^0.+$/

export const mobileRegEx = /((07)|((\+|00)447)){1}[0-9]{9}\b/ // Check if the mobile phone number

export const postcodeRegEx = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/
